import { ValueObject } from './value-object';

/**
 * Represents a globally unique identifier (GUID) which extends the ValueObject class.
 *
 * This class provides static methods to create a valid GUID, ensuring that it follows the
 * UUID v4 pattern. It also includes methods to validate and convert the GUID to a string format.
 */
export class Guid extends ValueObject<string, 'Guid'> {
  private constructor(guid: string) {
    super(guid);
  }

  public static create(guid?: string): Guid {
    guid ??= window.crypto.randomUUID();
    if (!this.isValidV4Guid(guid)) {
      throw new Error('Invalid guid');
    }
    return new Guid(guid);
  }

  public override toString(): string {
    return this.value as string;
  }

  private static isValidV4Guid(guid: string): boolean {
    const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return regex.test(guid);
  }
}
